import Promise from 'bluebird';
import _ from 'lodash';

import worldMap from '../../core/map';
import { pinBuilder } from '../../core/map/pinBuilder';
import streetView from '../../core/map/streetview';
import templates from '../../core/templates';
import ColorBrewer from '../../core/tools/colorbrewer';
import environment from '../../environment';
import Leaflet from './../Leaflet';
import { VehicleTypeEnum } from '../../core/vehicleType/constants';
import { CONFIG } from '../../../config';
import HaloLayer from '../HaloLayer';

const LayerControls = name => require('../../controls').get(name);
const get = (name, currentMap = worldMap.getCurrent()) => {
    return require('./../index').default.get(name, currentMap);
};

class DealershipAfterSalesLayer {
    constructor(currentMap) {
        const contextType = 'DealershipAfterSales';
        const mapId = +currentMap._id;

        const clusterImage = new Image();
        clusterImage.src = `${environment.get('IMAGES_HOST')}/icon_marker_parts.png`;

        const onReload = features => {
            const f = LayerControls(contextType);
            const layerType = f.getControls(mapId).buttonGroup.layerType.type;

            if (layerType === 'decluster') {
                get(contextType, currentMap).setOptions({ controlRange: 0.025, type: 'cluster' });
            } else if (layerType === 'cluster' && get(contextType, currentMap).options.controlRange === 1) {
                get(contextType, currentMap).setOptions({ controlRange: 30 });
            }

            return new Promise(resolve => {
                resolve(features);
            });
        };

        const createClusterTemplate = cluster => {
            const f = LayerControls(contextType);
            const layerType = f.getControls(mapId).buttonGroup.layerType.type;

            const images = _(cluster.getAllChildMarkers())
                .map(m => `${environment.get('IMAGES_HOST')}/pin_${String(m.feature.properties.BrandName).toUnderscoreCase()}_xs.png`)
                .uniqBy(i => i)
                .value();

            const data = {
                value: cluster.getChildCount(),
                images
            };

            if (currentMap.getZoom() < 14 && layerType !== 'decluster') {
                return pinBuilder.create.pin.imageWithValue(data, clusterImage);
            } else {
                return pinBuilder.create.pin.cluster(data);
            }
        };

        const createPopupTemplate = (properties, layer) =>
            new Promise((resolve) => {
                const $template = $(templates('map-layer-dealership-popup-after-sales', properties));

                const coordinates = {
                    lat: layer.feature.geometry.coordinates[1],
                    lng: layer.feature.geometry.coordinates[0]
                };

                const imageUrl = `${CONFIG.STORE_THUMBS_HOST}/${properties.Id}.jpg`;

                streetView.thumbnail($template.find('.leaflet-popup-image'), coordinates, imageUrl).then(() => {
                    resolve($template);
                });
            });

        const onClick = (feature, layer) => {
            LayerControls(contextType).highlight(layer);
            layer.closePopup();
            LayerControls(contextType).show({
                show: true,
                id: feature.properties.Id
            });

            return new HaloLayer(currentMap, layer, feature, contextType);
        };

        const onComplete = (features) => {
            return LayerControls(contextType).show({
                show: true,
                refresh: true
            }, features);
        };

        return new Leaflet.GeoJSONLayer({
            map: currentMap,
            id: `spatial_${contextType.toLowerCase()}_layer`,
            remote: {
                url: `${environment.get('API_HOST')}/aftersales/dealerships`,
                method: 'GET',
            },
            scaleRange: [5, 20],
            filter: {
                location: true
            },
            showAll: true,
            autofocus: false,
            uniqueField: 'Id',
            cache: true,
            sort: 'BrandName',
            reload: onReload,
            click: onClick,
            done: onComplete,
            popup: {
                template: createPopupTemplate,
                trigger: 'mouseover',
                options: {
                    offset: L.point(0, -50),
                    closeButton: false,
                    autoclose: true,
                    maxWidth: 600,
                },
                single: true
            },
            type: 'cluster',
            symbology: {
                type: 'polymorph',
                cluster: {
                    disableAtZoom: 20,
                    template: createClusterTemplate
                },
                heat: {
                    theme: ColorBrewer.getHeatColors(ColorBrewer.RED_YELLOW_GREEN)
                },
                style: {
                    icon: {
                        iconUrl: 'asdfasdfasdf',
                        getUrl: DealershipAfterSalesLayer.getApplicatorUrlIcon(),
                        iconSize: DealershipAfterSalesLayer.getIconSize(),
                        iconAnchor: [25, 60],
                        labelAnchor: [25, -32],
                        className: 'store-marker-icon',
                    },
                    riseOnHover: true
                }
            }
        });
    }

    static getIconSize = () =>
        (data) => {
            const { IsActive } = data;

            if (IsActive)
                return [38, 48];


            return [50, 64];
        }

    static getApplicatorUrlIcon = () => {
        return ({ BrandName, TypeStoreName }) => {
            const { imgSuffix } = get('DealershipAfterSales').options.symbology.style.icon;
            const url = environment.get('CONFIG.USERVEHICLETYPE') === VehicleTypeEnum.Moto
                ? `${environment.get('IMAGES_HOST')}/motos`
                : `${environment.get('IMAGES_HOST')}`;
            const brand = String(BrandName).toUnderscoreCase();
            let typeStore = `_${String(TypeStoreName).toUnderscoreCase()}`;

            if (imgSuffix) {
                typeStore = '';
            }

            return `${url}/pin_${brand}${typeStore}${(imgSuffix || '')}.png`;
        };
    }
}

export default DealershipAfterSalesLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/AfterSales/DealershipAfterSalesLayer.js